import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'

export default function ForgetPassword2() {
let [otp ,setOtp]=useState("")
let [show,setShow]=useState(false)
let [errorMessage,setErrorMessage]=useState("")
 let navigate = useNavigate()
const getInputData=(e)=>{
  setShow(false)
  setErrorMessage("")
   setOtp(e.target.value)
}

const postData=async(e)=>{
  e.preventDefault()
  try {
    const response = await fetch("/api/user/forget-password-2", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({username :localStorage.getItem("password-reset-admin"), otp:otp})
    });

    const result = await response.json();

    if (result.result === "Done") {
      navigate("/forget3"); // Make sure this is the next intended step
    } else {
      setErrorMessage(result.reason || "Something went wrong");
    }

  } catch (error) {
    console.error("POST error:", error);
    setErrorMessage("Server Error. Please try again.");
  }
}

  return (
    <>
        <div className="forget-pass-banner1">
            {/* <img src="/images/classicroom1.JPG" alt="" /> */}
        </div>

    <div className="container"> 
        <div className="main-forget">
        <div className="container-fluid">
            <div className="row">
                <div className="col-md-6 col-sm-12 col-12 mt-3 forger-pass-left">
                    <img src="/images/forget-password_.svg" loading="lazy" alt="V_Hotel_the_grnad_shoba Forget_password2 " title='V_Hotel_the_grnad_shoba_forget_password Title' />

                </div>
                <div className="col-md-6 col-sm-12 col-12 mt-5 forger-pass-right">
                <h1 className="mb-2">Forgot your password ??</h1>
          <p className="text-muted mb-4">
            Please enter the email address you'd like your password reset information sent to.
          </p>

          <form onSubmit={postData}>
            <div className="mb-3 col-md-12 forget-password-input">
                <p>OTP*</p>
              <input
               name='otp'
                onChange={getInputData}
                type="number"
                className="form-control"
                placeholder="Enter your OTP "
              />
               {show && errorMessage ? <p className='text-danger text-capitalize'>{errorMessage}</p>:""}
            </div>
            <div className="mb-3 col-md-12 forget-btn  ">
              <button className="btn btn-primary w-100">
                Submit OTP
              </button>
            </div>
         
           
          </form>
         
        </div>
                </div>
            </div>
        </div>
        </div>
    
    </>
  )
}
